module.exports = __webpack_public_path__ + "static/img/review-popup-title-bg.e2448c27.png";